module.exports = __webpack_public_path__ + "assets/img/b111-mu.svg";